import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
const RollOffDetailsRoutesContext = createContext(null);
export const RollOffDetailsRoutesProvider = ({ routes, children }) => (_jsx(RollOffDetailsRoutesContext.Provider, { value: routes, children: children }));
export const useRollOffDetailsRoutes = () => {
    const routes = useContext(RollOffDetailsRoutesContext);
    if (!routes)
        throw new Error('useRollOffDetailsRoutes must be used inside RollOffOrderDetails');
    return routes;
};
//# sourceMappingURL=routes-context.js.map